import { getRandomArrayItem } from '@material-bank/ds-utils';

import { AuthFlowViewData } from '../../../../../modules/auth';
import { IntlTranslationData } from '../../../../../shared/config/i18n';
import { getMediaUrl } from '../../../../../shared/config/media';
import { translations } from '../../../i18n';

export interface SignInViewVariantData extends Partial<AuthFlowViewData> {
  leftContentTitleTranslation?: IntlTranslationData;
}

const SIGN_IN_VIEW_VARIANTS: SignInViewVariantData[] = [
  {
    leftContentTitleTranslation: translations.signInView.leftTitle1,
    leftContentBg: '#E09A73',
  },
  {
    leftContentTitleTranslation: translations.signInView.leftTitle2,
    leftContentBg: '#ACA599',
    leftContentImageSrc: getMediaUrl('/registration/box-1-cropped.webp'),
    leftContentImagePlacement: 'right',
  },
  {
    leftContentTitleTranslation: translations.signInView.leftTitle3,
    leftContentBg: '#6684A2',
    leftContentImageSrc: getMediaUrl('/registration/box-2-cropped.webp'),
    leftContentImagePlacement: 'right',
  },
  {
    leftContentTitleTranslation: translations.signInView.leftTitle4,
    leftContentBg: '#37A490',
    leftContentImageSrc: getMediaUrl('/registration/box-3-cropped.webp'),
    leftContentImagePlacement: 'right',
  },
];

export const RANDOM_SIGN_IN_VIEW_VARIANT = getRandomArrayItem(
  SIGN_IN_VIEW_VARIANTS,
);
